import React,{useEffect} from 'react'
import './FacultyDashboard.css'
import FacultySubjectCard from './FacultySubjectCard'
import { useFacultyOptionsStore,useAppStore } from "../../stores";

const FacultyDashboard = () => {
  const addAllCourses = useFacultyOptionsStore((state) => state.addAllCourses);
  const courses = useFacultyOptionsStore((state) => state.courses);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  
  useEffect(() => {
    showLoading();
    fetch("/api/faculty/options")
      .then((res) => {
        hideLoading();
        if (res.status !== 200) {
          res.json()
            .then(r => console.log(r.message))
        }
        else {
          res.json().then(response => {
            console.log(response);
            addAllCourses(response.courses);
          })
        }
      })
  }, [])
  if(courses.length<1){
    return <h6>No courses for u...</h6>
  }
    return (
        <div className='row p-3'>
          {courses.map((course)=>(
            <FacultySubjectCard course={course} />
          ))}
        </div>
    )
}

export default FacultyDashboard